import storeFactory from '@/helpers/storeFactory'

export default storeFactory({
  model: { event_uuid: null, demand: null, assigned: null, location: null },
  getters: {
    newItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const yellow_vests = trafficMessageModel.yellow_vests
      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )
      return checkedItems.filter(x => !yellow_vests.includes(x.uuid)).length
    },

    missingItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const yellow_vests = trafficMessageModel.yellow_vests
      const missingItems = yellow_vests.filter(
        uuid => state.data[uuid] && !state.data[uuid].checked
      )
      return missingItems.length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
